export const assetURLs = {
  starryDiamond: new URL('./starry_diamond.png', import.meta.url).href,
}